import { TConfigItem } from './api-type';

/** 返回给页面的配置 */
export type IPageInfo = TConfigItem;

/** 配置类型 */
export enum ConfigType {
  /** 普通活动的端外配置 */
  general = 'general',
  /** 物料的端外配置 */
  material = 'material',
}
